import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Row, Col, Table } from 'antd'
import '../../../css/patient.scss'
import _ from 'lodash'
import * as d3 from 'd3'
import { MODAL_TYPE } from '.'
import { CHART_COLORS } from '../../../util/chartPalette'
import { DataViewToggle } from '../../graph/chartDataView'
import { formatDateTimeET } from '../../../util/datetime'

const Extension = (props) => {
  const ref = useRef(null)
  const ref2 = useRef(null)
  const label = ['', '0-50', '50-80', '80-90', 'unknown', '']
  const [view, setView] = useState('chart')

  useEffect(() => {
    if (view === 'chart') drawLineCharts()
  }, [props.data, view])

  var drawLineCharts = () => {
    var margin = { top: 20, right: 15, bottom: 20, left: 55 }
    var screenHeight = props.fullscreen ? 300 : 155,
      screenWidth = props.fullscreen
        ? props.width > 0
          ? props.width
          : ref2.current && ref2.current.offsetWidth
          ? ref2.current.offsetWidth
          : 370
        : 280

    var height = screenHeight - 15 - margin.top - margin.bottom,
      width = screenWidth - margin.left - margin.right

    let color = CHART_COLORS.lineBlue

    let svg = d3.select(ref.current).attr('opacity', '0')
    //.attr('width', "100%" )
    //.attr('height', screenHeight )

    var x = d3
      .scalePoint()
      // d3.scaleBand()
      .domain(props.data.map((d) => d.date))
      .rangeRound([0, width])
      .padding(0.2)

    var y = d3.scaleLinear().rangeRound([height, 0]).domain([0, 5])

    var g = svg
      .append('g')
      .attr('transform', `translate(${margin.left},${margin.top})`)

    var line = d3
      .line()
      .x((d, i) => x(d.date)) // set the x values for the line generator
      .y((d) => y(d.score)) // set the y values for the line generator
      .curve(d3.curveMonotoneX) // apply smoothing to the line

    g.append('g')
      .attr('class', 'x axis')
      .attr('stroke', 'black')
      .attr('transform', 'translate(0,' + height + ')')
      .append('text')
      .attr('y', 76)
      .attr('x', screenWidth / 2 - 70 + margin.left)
      .attr('text-anchor', 'end')
      .attr('letter-spacing', 2)
      .attr('stroke', 'black')
      .text('Date')

    g.append('g')
      .attr('class', 'x axis')
      .attr('stroke', 'black')
      .attr('transform', 'translate(0,' + height + ')')
      .call(d3.axisBottom(x))
      .selectAll('text')
      .style('text-anchor', 'end')
      .attr('dx', '-.8em')
      .attr('dy', '.15em')
      .attr('transform', 'rotate(-45)')
      .style('font-size', '10px')

    let callYaxis = d3
      .axisLeft(y)
      .ticks(4)
      .tickFormat((d, i) => `${label[d]}`)

    g.append('g')
      .attr('class', 'y axis')
      .attr('stroke', 'black')
      .call(callYaxis) // Create an axis component with d3.axisLeft
      .append('text')
      .attr('y', -10)
      .attr('x', 7)
      .attr('text-anchor', 'end')
      .attr('letter-spacing', 2)
      .attr('stroke', 'black')
      .text('Degree')

    appendLine(g, line, color)
    appendDots(g, x, y, color, label)
    //  appendBars(g, x, y, color, label,height);
    styleTickText()
    setTimeout(() => {
      svg
        .attr('opacity', '1')
        .attr('width', '100%')
        .attr('height', screenHeight)
    }, 300)
  }

  var appendDots = (g, x, y, color, label) => {
    var tooltip = d3
      .select(ref2.current)
      .append('div')
      .attr('class', 'chartToolTip')
      .style('position', 'absolute')
      .style('z-index', '10')
      .style('visibility', 'hidden')
    // .text("a simple tooltip");

    g.selectAll('.dot')
      .data(props.data)
      .enter()
      .append('circle') // Uses the enter().append() method
      .attr('class', 'dot') // Assign a class for styling
      .attr('fill', color)
      .attr('stroke', 'transparent')
      .attr('stroke-width', 10)
      .attr('cx', function (d, i) {
        return x(d.date)
      })
      .attr('cy', function (d) {
        return y(d.score)
      })
      .attr('r', 4)
      .style('cursor', 'pointer')
      .on('mouseover', function (d, i) {
        tooltip.html(
          `<b>Date</b>: ${d.date} </br> <b>Degree</b>: ${label[d.score]}`
        )
        var left = !props.fullscreen && i == props.data.length - 1 ? 50 : 0
        tooltip
          .style('visibility', 'visible')
          .style('top', d3.select(this).attr('cy') - 42 + 'px')
          .style('left', d3.select(this).attr('cx') - left + 'px')
      })
      .on('mouseout', (event) => tooltip.style('visibility', 'hidden'))

    // g.selectAll("dot")
    // .data(props.data)
    // .enter()
    // .append("text").text(function(d, i){console.log(d);
    //    return `${label[d.score]}`})
    //    .attr("x",  function(d, i) { return x(d.date) +(i==0? 2 :-20)})
    //    .attr("y",function(d,i) { return y(d.score)+(i%2==0 ?-10 :15) });
    g.selectAll('dot')
      .data(props.data)
      .enter()
      .append('text')
      .text(function (d, i) {
        return `${label[d.score]}`
      })
      .attr('x', function (d, i) {
        // return x(d.date) +(i==0? 2 :-20)
        return x(d.date) + 10
      })
      .attr('y', function (d, i) {
        // return y(d.score)+(i%2==0 ?-10 :15)
        return y(d.score) + 5
      })
      .attr('transform', function (d, i) {
        return `rotate(-45, ${x(d.date)}, ${y(d.score)})`
      })
  }

  var appendLine = (g, line, color) => {
    g.append('path')
      .datum(props.data) // Binds data to the line
      .attr('class', 'line' + color) // Assign a class for styling
      .attr('stroke-width', 2)
      .attr('stroke', color)
      .attr('fill', 'none')
      .attr('d', line) // Calls the line generator
  }

  var styleTickText = () => {
    let ticks = document.getElementsByClassName('tick')
    d3.selectAll(ticks).each(function (d, i) {
      d3.select(this).style('fill', 'black').style('stroke-width', '0.5px')
    })
  }

  var appendBars = (g, x, y, color, label, height) => {
    var tooltip = d3
      .select(ref2.current)
      .append('div')
      .attr('class', 'chartToolTip')
      .style('position', 'absolute')
      .style('z-index', '10')
      .style('visibility', 'hidden')

    g.selectAll('.bar')
      .data(props.data)
      .enter()
      .append('rect')
      .attr('class', 'bar')
      .attr('fill', color)
      .attr('x', (d) => x(d.date))
      .attr('y', (d) => y(d.score))
      .attr('width', x.bandwidth())
      .attr('height', (d) => height - y(d.score))
      .style('cursor', 'pointer')
      .on('mouseover', function (event, d) {
        tooltip.html(
          `<b>Date</b>: ${d.date} <br/> <b>Degree</b>: ${label[d.score]}`
        )
        tooltip
          .style('visibility', 'visible')
          .style('top', d3.select(this).attr('y') - 42 + 'px')
          .style('left', d3.select(this).attr('x') + 'px')
      })
      .on('mouseout', () => tooltip.style('visibility', 'hidden'))
  }

  // `data.time` is the real submit timestamp; `data.date` is a date-only
  // string fallback. Render and sort on the real timestamp where available.
  const columns = [
    {
      title: 'Date',
      defaultSortOrder: 'descend',
      sorter: (a, b) =>
        new Date(a.time || a.date).getTime() - new Date(b.time || b.date).getTime(),
      render: (data) => {
        if (!data) return 'NA'
        return formatDateTimeET(data.time || data.date)
      },
    },
    {
      title: 'Score',
      render: (data) => {
        return label[data.score]
      },
    },
  ]

  const viewTable = () => (
    <div style={{ padding: 10, margin: 15 }}>
      <Table
        columns={columns}
        dataSource={props.data}
        showHeader
        bordered
        pagination={{ pageSize: 10, hideOnSinglePage: true, size: 'small' }}
        style={{ width: '80%', borderWidth: 2, padding: 10 }}
      />
    </div>
  )

  return (
    <>
      <center>
        <h4>Extension</h4>
      </center>
      {props.data?.length > 0 ? (
        <div>
          <Row justify='end' style={{ marginBottom: 4, paddingRight: 20 }}>
            <DataViewToggle
              active={view === 'data'}
              onClick={(e) => {
                e.stopPropagation()
                setView(view === 'data' ? 'chart' : 'data')
              }}
            />
          </Row>
          {view === 'data' ? (
            viewTable()
          ) : (
            <div
              ref={ref2}
              onClick={() => !props.fullscreen && props.onClick(MODAL_TYPE.OKS)}
            >
              <svg
                style={{ paddingLeft: '0px', height: '350px', minWidth: '400px' }}
                ref={ref}
              ></svg>
            </div>
          )}
        </div>
      ) : (
        <Row justify='center' align='middle' style={{ height: 200 }}>
          <h2>Data not available</h2>
        </Row>
      )}
    </>
  )
}

Extension.propTypes = {
  patient: PropTypes.object,
  getReport: PropTypes.func,
  showtips: PropTypes.bool,
  fullscreen: PropTypes.bool,
  onClick: PropTypes.func,
}

const mapStateToProps = (state) => {
  return {
    patient: state.patient.patient,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(Extension)
